import React, { useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { AppearFromBottom, QuicklinkButton, QuickLinkText } from "global/style";
import { translate, language } from "_helpers/general.helper";
import { chatActions } from "_actions";
import { useEffect } from "react";

const ReviewQuicklinksContainer = styled.div`
  padding-left: 0px;
  display: block;

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakXsmall}) {
    padding-left: 3px;
  }

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    padding-left: 0;
  }
`;

const FullWidthQuicklinkButton = styled(QuicklinkButton)`
  width: 100%;
`;
const ReviewQuicklinksWrapper = styled(AppearFromBottom)`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  flex-flow: row wrap;
  align-content: space-between;
  padding-left: 0;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-item-align: flex-start;
  align-self: center;
  -webkit-box-align: start;
  -ms-flex-align: start;
  grid-gap: 7px;
  margin-bottom: 5px;
`;

const ReviewText = styled(QuickLinkText)`
  font-weight: 700;
  border: solid 2px #0f0538 !important;
  padding: 0 8px;
  height: 80px;
  border-radius: 46px;
  width: fit-content;
  display: grid;
  grid-template-columns: 1fr 4fr 1fr 2fr;
  align-items: center;

  &:hover {
    cursor: pointer;
  }

`;

const ReviewScore = styled.div`
  width: 35px;
  height: 35px;
  font-size: 20px;
  color: white;
  background: #42accd;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

@media screen and (min-width: ${(props) =>
  props.theme.screenSizes.breakLaptop}) { 
    width: 40px;
    height: 40px;
  }

`;

const ReviewStarsImage = styled.img`
width: 100%;
max-width: 250px;
`;

const ReviewerLogoImage = styled.img`
  width: 60px;
  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    width: 90px;
  }

  @media screen and (min-width: ${(props) =>
    props.theme.screenSizes.breakLaptop}) { 
      width: 100px;
    }

`;

const ReviewLogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  top: -5px;
`;
const ReviewNumberText = styled.div`
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  text-align: start;
  margin-top: -10px;
  bottom 1rem;
  color: ${(props) => props.color};

  @media screen and (min-width: ${(props) =>
    props.theme.screenSizes.breakSmall}) {
    font-size: 14px;
  }
  @media screen and (min-width: ${(props) =>
    props.theme.screenSizes.breakLaptop}) {
    font-size: 19px;
  }
`;

const HorizontalLineSeparator = styled.div`
  width: 0px;
  height: 3.6rem;
  border: 1.3px solid #d9d9d9;
  color: #d9d9d9;
  background: #d9d9d9;
  margin-right: 1rem;
  margin-left: 1rem;
`;

function ReviewList({ data, tid, send }) {
  const YELP_LIGHT_LOGO_SRC =
    "images/yelp_logos/Logo/Light bg/RGB/yelp_logo.png";
  const YELP_DARK_LOGO_SRC =
    "images/yelp_logos/Logo/Dark bg/RGB/yelp_logo_dark_bg.png";
  const YELP_STARS_BASE_PATH = "images/yelp_stars/web_and_ios";

  const GOOGLE_LIGHT_LOGO_SRC = "images/google_logos/google.png";
  const GOOGLE_STARS_BASE_PATH = "images/google_stars";

  const [reviewProvider, setReviewProvider] = useState({
    Yelp: {
      review_text_color: "#6f6e6e",
      logo_src: YELP_LIGHT_LOGO_SRC,
      stars_src: "",
      base_path: YELP_STARS_BASE_PATH,
      stars_folder: "regular",
      stars_prefix: "regular",
      stars_suffix: "@3x.png",
    },
    Google: {
      review_text_color: "#6f6e6e",
      logo_src: GOOGLE_LIGHT_LOGO_SRC,
      stars_src: "",
      base_path: GOOGLE_STARS_BASE_PATH,
      stars_folder: "regular",
      stars_prefix: "regular",
      stars_suffix: ".svg",
    },
  });

  useEffect(() => {
    data.map((item) => {
      let { base_path, stars_folder, stars_prefix, stars_suffix } =
        reviewProvider[item.provider];
      let starFormatted = String(item.rating)
        .replace(".3", "_half")
        .replace(".4", "_half")
        .replace(".5", "_half")
        .replace(".6", "_half")
        .replace(".7", "_half");
      starFormatted = starFormatted
        .replace(".0", "")
        .replace(".1", "")
        .replace(".2", "");
      if (starFormatted.endsWith(".8") || starFormatted.endsWith(".9")) {
        starFormatted = Math.ceil(starFormatted);
      }
      let fullImgPath = `${base_path}/${stars_folder}/${stars_prefix}_${starFormatted}${stars_suffix}`;

      let prevObj = { ...reviewProvider };
      prevObj[item.provider].stars_src = fullImgPath;

      setReviewProvider(prevObj);
    });
  }, [data]);

  const handleClick = (property) => {
    send({ text: property.text, value: property.value }, "text");
  };

  const handleKeyPress = (e, property) => {
    if (e.key === "Enter" || e.key === " ") {
      handleClick(property);
    }
  };

  const handleStarsImageLoadFail = (e) => {
    e.target.src = `images/yelp_stars/web_and_ios/regular_0@3x.png`;
  };
  const handleLogoImageLoadFail = (e) => {
    e.target.src = `images/yelp_logos/Logo/Light bg/RGB/yelp_logo.png`;
  };

  const toggleImageColors = (provider, color) => {
    let logo = "";

    if (provider == "Yelp" && color == "dark") {
      logo = YELP_DARK_LOGO_SRC;
    } else {
      logo = YELP_LIGHT_LOGO_SRC;
    }

    if (provider == "Google") {
      logo = GOOGLE_LIGHT_LOGO_SRC;
    }

    let prevObj = { ...reviewProvider };
    prevObj[provider].logo_src = logo;
    prevObj[provider].review_text_color = color == "dark" ? "#fff" : "#6F6E6E";
    setReviewProvider(prevObj);
  };

  return (
    <ReviewQuicklinksContainer className="ReviewQuicklinksContainer">
      <ReviewQuicklinksWrapper className="ReviewQuicklinksWrapper">
        {data.map((business, key) => {
          return (
            <FullWidthQuicklinkButton
              key={`multibot-quicklink-${key}`}
              onClick={() => handleClick(business)}
              tabIndex={0}
              role="button"
              onKeyPress={(e) => handleKeyPress(e, business)}
            >
              <ReviewText
                className="ReviewText quicklinks"
                tabIndex={-1}
                onMouseOver={() => toggleImageColors(business.provider, "dark")}
                onMouseLeave={() =>
                  toggleImageColors(business.provider, "light")
                }
              >
                <ReviewScore>{business.rating}</ReviewScore>
                <ReviewStarsImage
                  onError={handleStarsImageLoadFail}
                  src={reviewProvider[business.provider].stars_src}
                  alt="Stars Rating"
                />
                <HorizontalLineSeparator />
                <ReviewLogoWrapper>
                  <ReviewerLogoImage
                    onError={handleLogoImageLoadFail}
                    src={reviewProvider[business.provider].logo_src}
                    alt="Logo Image"
                  />
                  <ReviewNumberText
                    color={reviewProvider[business.provider].review_text_color}
                  >
                    {business.total_reviews}{" "}
                    {translate("Reviews", language(tid))}
                  </ReviewNumberText>
                </ReviewLogoWrapper>
              </ReviewText>
            </FullWidthQuicklinkButton>
          );
        })}
      </ReviewQuicklinksWrapper>
    </ReviewQuicklinksContainer>
  );
}

const mapStateToProps = (state) => ({
  tid: state.settings.tid,
});

const actions = {
  send: chatActions.send,
};

export default connect(mapStateToProps, actions)(ReviewList);
